import script from "./CustomLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomLinks.vue?vue&type=script&setup=true&lang=js"

import "./CustomLinks.vue?vue&type=style&index=0&id=0341fd65&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0341fd65"]])

export default __exports__